import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/layout/auth-layout.vue'
import AppLayout from '@/layout/app-layout.vue'
import store from "@/store";
import JwtService from '@/services/extensions-service/JwtService'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: "/:catchAll(.*)",
    redirect: { name: '404' }
  },
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        name: "dashboard",
        path: 'dashboard',
        component: () => import('@/pages/Dashboard.vue'),
      },
      {
        name: "home",
        path: 'home',
        component: () => import('@/pages/HomeView.vue'),
      },
      {
        name: "about",
        path: 'about',
        component: () => import('@/pages/AboutView.vue'),
      },
      {
        name: "custom",
        path: 'custom',
        component: () => import('@/pages/Custom.vue'),
      },
      {
        name: '404',
        path: '404',
        component: () => import('@/pages/404-pages/VaPageNotFoundSimple.vue'),
      },
      {
        name: 'allocate-package',
        path: 'allocate-package',
        component: () => import('@/pages/AllocatePackage.vue'),
      },
      {
        name: 'topup',
        path: 'topup',
        component: () => import('@/pages/Topup.vue'),
      },
      {
        name: 'transfer-credit',
        path: 'transfer-credit',
        component: () => import('@/pages/Selling/TransferCredit.vue'),
      },
      {
        name: 'topuphistory',
        path: 'topuphistory',
        component: () => import('@/pages/TopupHistory.vue'),
      },
      {
        name: 'mystock',
        path: 'mystock',
        component: () => import('@/pages/Selling/MyStock.vue'),
      },
      {
        name: 'setup-vc-price',
        path: 'setup-vc-price',
        component: () => import('@/pages/Selling/SetupVoucherPrice.vue'),
      },
      {
        name: 'stockpurchase',
        path: 'stockpurchase',
        component: () => import('@/pages/Selling/StockPurchase.vue'),
      },
      {
        name: 'checkpayment',
        path: 'checkpayment',
        props: true,
        component: () => import('@/pages/Selling/CheckPayment.vue'),
      },
     
      {
        name: 'setup-datapack-voucher',
        path: 'setup/DatapackVoucher',
        component: () => import('@/pages/Setup/DatapackVoucher.vue'),
      },
      {
        name: 'setup-subscription',
        path: 'setup/subscription',
        component: () => import('@/pages/Setup/Setup-Subscription.vue'),
      },
      {
        name: 'setup-retailer',
        path: 'setup/retailer',
        component: () => import('@/pages/Setup/Setup-Retailer.vue'),
      },
      {
        name: 'subscription-user',
        path: 'subscription-user',
        component: () => import('@/pages/ShowSubscriptionByUser.vue'),
      },
      {
        name: 'check-voucher',
        path: 'check-voucher',
        component: () => import('@/pages/Selling/CheckVoucher.vue'),
      },
    ]
  },
  {
    path: '/report',
    component: AppLayout,
    children: [
      {
        name: 'report-online-users',
        path: 'online-users',
        component: () => import('@/pages/reports/Onlineusers.vue'),
      },
      {
        name: 'purchase',
        path: 'purchase',
        component: () => import('@/pages/reports/Purchase.vue'),
      },
      {
        name: 'report-transfer',
        path: 'report-transfer',
        component: () => import('@/pages/reports/Report-Transfer.vue'),
      },
      {
        name: 'report-purchase',
        path: 'report-purchase',
        component: () => import('@/pages/reports/Report-Purchase.vue'),
      },
      {
        name: 'report-sale',
        path: 'report-sale',
        component: () => import('@/pages/reports/Report-Sale.vue'),
      },
      {
        name: 'tax-receipt',
        path: 'tax-receipt',
        component: () => import('@/pages/reports/MonitorTaxReceipt.vue'),
      },
      {
        name: 'report-datausage',
        path: 'report-datausage',
        component: () => import('@/pages/reports/Report-DataUsage.vue'),
      },
      {
        name: 'report-newregister',
        path: 'report-newregister',
        component: () => import('@/pages/reports/Report-NewRegister.vue'),
      },
      {
        name: 'report-revenue',
        path: 'reports/report-revenue',
        component: () => import('@/pages/reports/Report-Revenue.vue'),
      },
      {
        name: 'report-revenue',
        path: 'report-revenue',
        component: () => import('@/pages/reports/Report-Revenue.vue'),
      }
    ]
  },
  {
    path: '/management',
    component: AppLayout,
    children: [

      {
        name: 'contract-management',
        path: 'contract',
        component: () => import('../pages/managements/ContractManagement.vue'),
      },
      {
        name: 'reconcile-subscription-contract',
        path: 'subscription-contract',
        component: () => import('../pages/managements/ReconcileSubscriptionContract.vue'),
      }
    ]
  },
  {
    path: "/",
    component: AuthLayout,
    children: [
      {
        name: "login",
        path: 'login',
        component: () => import('@/pages/auth/Login.vue'),
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async function (to, _, next) {
  const code = store.state.code.accessToken;
  const mainMenu = store.state.mainMenu;
  const response = await new JwtService().filter(mainMenu, to.name)
  if (typeof code === 'undefined' && to.name != 'login') {
    store.commit('logOut');
    next({ name: 'login' });
  }
  else {
    if (response.length <= 0 && to.name != '404' && to.name != 'login') {
      next({ name: '404' });
    }
    else {
      next();
    }
  }
});

export default router;
